import React from 'react'

const Footer = () => {
  return (
    <footer className='py-5 sm:px-10 px-5'>
        <div className='screen-max-width'>
            <div >
                <p className='font-semibold text-gray text-xs'>
                Designed by: {''} 
                <span className='underline text-blue'>
                    Richard Nyande
                </span>
                </p>
                
            </div>
        </div>
    </footer>
  )
}

export default Footer